<template>
  <div class="not-found">
    <div class="not-found__container">
      <div class="not-found__hero">
        <h1 class="not-found__title">Page not found</h1>
        <p class="not-found__message">
          The page you are looking for does not exist or has been moved
        </p>
      </div>

      <div class="not-found__actions">
        <button class="button button--primary" @click="back">
          <span class="button__icon">←</span>
          go back
        </button>
        <router-link to="/" class="button button--secondary">
          <icon-address class="my-account__menu-icon"/>
          Home
        </router-link>
        <router-link :to="{ name: 'shop' }" class="button button--secondary">
          <icon-orders class="my-account__menu-icon"/>
          Shop
        </router-link>
        <router-link :to="{ name: 'blog' }" class="button button--secondary">
          <icon-blog class="my-account__menu-icon"/>
          Blog
        </router-link>
      </div>
    </div>

    <div class="not-found__section">
      <blocks-related-products use-slider />
    </div>

    <div class="not-found__section">
      <h2 class="not-found__section-title">Suggested Blog Posts</h2>
      <blocks-related-posts />
    </div>
  </div>
</template>

<script>
import IconAddress from "~/assets/icons/IconHome.svg";
import IconOrders from "~/assets/icons/IconOrders.svg";
import IconBlog from "~/assets/icons/IconBlog.svg";

export default {
  components: {IconOrders, IconAddress, IconBlog},
  methods: {
    back() {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss">
@use "~/common/scss/variables";

.not-found {
  min-height: 95vh;
  padding: 2rem 1rem;

  &__container {
    max-width: variables.$containerMedium;
    margin: 0 auto;
  }

  &__hero {
    margin-top: 1.2rem;
    text-align: center;
    padding: 0;
    margin-bottom: 2rem;
  }

  &__title {
    font-size: clamp(1.5rem, 4vw, 2.5rem);
    font-weight: 700;
    color: variables.$colorBlack;
    margin-bottom: 1rem;
    animation: fadeIn 0.8s ease-out;
  }

  &__message {
    font-size: clamp(1rem, 2vw, 1.25rem);
    color: variables.$colorGrey;
    max-width: 600px;
    margin: 0 auto 2rem;
    line-height: 1.6;
    animation: fadeIn 1s ease-out;
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    margin-bottom: 4rem;
    animation: fadeIn 1.2s ease-out;
  }

  &__section {
    max-width: variables.$containerMedium;
    margin: 0 auto 4rem;
  }

  &__section-title {
    font-size: clamp(1.5rem, 3vw, 2rem);
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 2rem;
    text-align: center;
  }

  .button {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.875rem 1.75rem;
    font-size: 1rem;
    font-weight: 600;
    text-decoration: none;
    border: none;
    border-radius: 0.75rem;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;

    &__icon {
      font-size: 1.25rem;
    }

    &--primary {
      background: variables.$colorOrange;
      color: white;
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
      }
    }

    &--secondary {
      background: white;
      color: variables.$colorOrange;
      border: 2px solid variables.$colorOrange;

      &:hover {
        background: variables.$colorOrange;
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
      }
    }
  }

  @media (max-width: variables.$bp-1-max) {
    padding: 1rem 0.5rem;

    &__hero {
      padding: 2rem 1rem 1rem 1rem;
    }

    &__actions {

      .button {
        justify-content: center;
        width: 60%;
        margin: 0 auto;
      }
    }
  }
}
</style>
